/**
 * Esta é uma função para converter um object em uma query string
 *
 * @example
 *   queryString(object) //"cod_destination=BR&initial_date=2020-02-05&..."
 *
 * @param   {Object} obrigatorio Parametro obrigatório
 * @returns {String} "cod_destination=BR&initial_date=2020-02-05&..."
 */
export function queryString (params) {
  return Object.keys(params)
    .map(key => {
      if (!params[key]) return
      return `${key}=${params[key]}`
    })
    .filter(key => key)
    .join('&')
}

/**
* Funcão para salvar os parâmetro na store
*/
export function URLSearchParams () {
  const _params = {}
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    _params[key] = value
  })

  return _params
}

export const replaceSpecialChars = (string) => string.toLowerCase()
  .replace(/[aáàâã]/gim, 'a')
  .replace(/[eéèê]/gim, 'e')
  .replace(/[iíïì]/gim, 'i')
  .replace(/[oóôõö]/gim, 'o')
  .replace(/[uú]/gim, 'u')
  .replace(/[cç]/gim, 'c')

export const removeAccent = (label) => label.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()

export const COVID_COVERS = [
  {
    id: 0,
    nationalId: 0,
    internationalId: 0,
    label: 'Não Incluir',
    value: 'Não Incluir'
  },
  {
    id: 1,
    nationalId: 5,
    internationalId: 1,
    label: 'COVID 5 CI',
    value: '5.000,00'
  },
  {
    id: 2,
    nationalId: 2,
    internationalId: 6,
    label: 'COVID 10 CI',
    value: '10.000,00'
  },
  {
    id: 3,
    nationalId: 3,
    internationalId: 7,
    label: 'COVID 20 CI',
    value: '20.000,00'
  },
  {
    id: 4,
    nationalId: 4,
    internationalId: 8,
    label: 'COVID 30 CI',
    value: '30.000,00',
    hasRecommended: true
  },
  {
    id: 5,
    nationalId: 9,
    internationalId: 10,
    label: 'COVID 50 CI',
    value: '50.000,00'
  }
]

export const COVID_COVERS_TOO = [
  {
    id: 0,
    nationalId: 0,
    internationalId: 0,
    label: 'Não Incluir',
    value: 'Não Incluir'
  },
  {
    id: 1,
    nationalId: 16,
    internationalId: 11,
    label: 'COVID 10 CI',
    value: '10.000,00'
  },
  {
    id: 2,
    nationalId: 17,
    internationalId: 12,
    label: 'COVID 30 CI',
    value: '30.000,00',
    hasRecommended: true
  },
  {
    id: 3,
    nationalId: 18,
    internationalId: 13,
    label: 'COVID 40 CI',
    value: '40.000,00'
  },
  {
    id: 4,
    nationalId: 19,
    internationalId: 14,
    label: 'COVID 30 CI + Prorrogação de estadia',
    value: '30.000,00',
    extraLabel: 'Com prorrogação de estadia*',
    checkoutLabel: 'com prorrogação de estadia'
  },
  {
    id: 5,
    nationalId: 20,
    internationalId: 15,
    label: 'COVID 40 CI + Prorrogação de estadia',
    value: '40.000,00',
    extraLabel: 'Com prorrogação de estadia*',
    checkoutLabel: 'com prorrogação de estadia'
  }
]
